import { LT_PROPERTIES_DATA_RECEIVED, LT_PROPERTY_UNLOADED, LT_PROPERTY_RECEIVED, LT_PROPERTY_SAVED, LT_PROPERTY_DELETED } from './types';
import api from 'api';

export const propertyLTDataReceived = (data) => ({
  type: LT_PROPERTIES_DATA_RECEIVED,
  data
})

export const propertyLTDataUnload = () => ({
  type: LT_PROPERTY_UNLOADED
})

export const propertyReceived = (data) => ({
  type: LT_PROPERTY_RECEIVED,
  data
})

export const propertySaved = (data) => ({
  type: LT_PROPERTY_SAVED,
  data
})

export const propertyDeleted = (data) => ({
  type: LT_PROPERTY_DELETED,
  data
})

export const unloadProperty = () => dispatch => {
  dispatch(propertyLTDataUnload())
}

// TODO: doebatsia do tracy
export const postProperty = (data) => dispatch => api.bmc.properties
  .postProperty(data).then(res=>{
    dispatch(propertySaved(res))
    return res
  })

// TODO: doebatsia do tracy 2, figure out the correct table
export const deleteProperty = (data) => dispatch => api.bmc.properties
  .deleteProperty(data).then(res=>{
    dispatch(propertyDeleted(data))
  })

// TODO: catch with user logout and user data not recived
export const getProperties = (view = false) => (dispatch) =>
    api.bmc.properties.getProperties(view?'viewTY':'').then( assets => {
    dispatch(propertyLTDataReceived(assets))
  });
